// extracted by mini-css-extract-plugin
module.exports = {"primary":"#587cf7","secondary":"#00bca2","highlight":"#fe6f61","success":"#30ce7e","warning":"#faaa14","danger":"#fb6160","light":"#eaeff9","dark":"#000206"};